import COMMENT from 'constants/comment';

export const addActionToComment = ({
  action,
  commentId,
  pages,
  handleActionCallback,
}) =>
  pages.map((page) =>
    page.map((comment) => {
      if (comment.commentId === commentId) {
        return handleActionCallback(comment, action);
      }

      const newComment = structuredClone(comment);

      newComment.replies = newComment.replies.map((reply) =>
        reply.commentId === commentId
          ? handleActionCallback(reply, action)
          : reply
      );

      return newComment;
    })
  );

export const isCommentContentBlocked = (commentStatusName) =>
  commentStatusName === COMMENT.STATUSES.REMOVED_BY_ADMIN ||
  commentStatusName === COMMENT.STATUSES.REMOVED_BY_USER ||
  commentStatusName === COMMENT.STATUSES.REMOVED_FOR_ALL;

// These statuses are only visible for the user who posted them
const isCommentVisible = ({ commentStatusName }) =>
  commentStatusName === COMMENT.STATUSES.WAITING ||
  commentStatusName === COMMENT.STATUSES.PROCESSING ||
  commentStatusName === COMMENT.STATUSES.REMOVED_BY_ADMIN;

export const isReplyFromTheSameUserOfParent = ({ replies, userId }) =>
  replies[0].userId === userId && isCommentVisible(replies[0]);

export const getCommentIdFromHash = (hash) => {
  if (hash?.includes('comment')) {
    try {
      const [hashId] = hash.match(/([0-9]+)/g);

      return Number(hashId);
    } catch {
      return null;
    }
  }

  return null;
};

// The `initialCommentCount` must be summed with the comments that
// only the user can see so we make sure to show the same
// comments count of comments that the user can actually access
export const getCommentsCount = (initialCommentCount, comments) =>
  initialCommentCount +
  getUserExclusiveRepliesCount(comments) +
  getUserExclusiveParentsCount(comments);

export const getDislikedComment = (comment, action) => {
  const newComment = comment;

  if (action === COMMENT.ACTIONS.DISLIKE) {
    if (newComment.commentLikes > 0 && comment.isLiked) {
      newComment.commentLikes -= 1;
    }

    newComment.isLiked = false;
    newComment.isDisliked = true;
  }

  if (action === COMMENT.ACTIONS.REMOVE) {
    newComment.isDisliked = false;
  }

  return newComment;
};

export const getLikedComment = (comment, action) => {
  const newComment = comment;

  if (action === COMMENT.ACTIONS.LIKE) {
    newComment.commentLikes += 1;
    newComment.isLiked = true;
    newComment.isDisliked = false;
  }

  if (action === COMMENT.ACTIONS.REMOVE) {
    newComment.commentLikes -= 1;
    newComment.isLiked = false;
  }

  return newComment;
};

const getUserExclusiveRepliesCount = (comments) => {
  let result = 0;

  for (const comment of comments) {
    result += comment?.replies.filter(isCommentVisible).length || 0;
  }

  return result;
};

const getUserExclusiveParentsCount = (comments) => {
  let result = 0;

  for (const comment of comments) {
    if (
      (comment.replies.length === 0 ||
        isReplyFromTheSameUserOfParent(comment)) &&
      isCommentVisible(comment)
    ) {
      result++;
    }
  }

  return result;
};

export const toFormattedCommentCount = (count) => {
  if (!count || count === 0) {
    return '0 comentários';
  }

  if (count === 1) {
    return '1 comentário';
  }

  return `${count} comentários`;
};
